<script>
	import { Col, Row } from "sveltestrap";
	export let title = "";
	export let onClick;
	export let titleStatusBar;
</script>

<Row className="row d-flex align-items-center">
	<Col>
		<div class="d-flex">
			{#if onClick}
				<div class="me-3 clickable">
					<img
						on:keyup={() => {}}
						on:click={onClick}
						src="/assets/icon-chevron-left-thin.svg"
						alt="back-button"
					/>
				</div>
			{/if}
			<div>
				<h4 class="d-flex align-items-center flex-row">
					<b>{title}</b>
					{#if !!titleStatusBar}
						<span class="ms-3 status-bar title-status-bar"
							>{titleStatusBar}</span
						>
					{/if}
				</h4>
			</div>
		</div>
	</Col>
	<Col xs="auto"><slot /></Col>
</Row>

<style>
	.clickable {
		cursor: pointer;
	}

	.title-status-bar {
		background-color: #ffca3d;
		color: #1f1700;
	}
</style>
